import React from 'react';
import Reviews from './Reviews';
import Companies from './Companies';
import Community from './Community';
import Ranking from './Ranking';
import { Tabs, Tab } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useHistory } from 'react-router';
import Info from './Info';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faStar, faTractor, faQuestionCircle, faListOl, faShoppingBasket, faTag } from '@fortawesome/free-solid-svg-icons';
import Sconti from './Sconti';
import Merch from './Merch';

export default function Tabelle() {
    const history = useHistory();

    let active_tab = history.location.pathname.split("/")[1]
    var search_filter = history.location.pathname.split("/")[2] === undefined ? "all":  history.location.pathname.split("/")[2] 
    history.listen(url =>  { 
        if(url.pathname.split("/")[1].includes("aziende")) 
            active_tab = "aziende"
        })

    function handleSelect(key) {
        let route
        if (key === "aziende")
            route = "aziende"
        else if (key === "recensioni")
            route = "recensioni/all"
        else if (key === "community")
            route = "community"
        else if (key === "classifiche")
            route = "classifiche"
        else if (key === "sconti")
            route = "sconti"
        else if (key === "info")
            route = "info"
        else if (key === "merch")
            route = "merch"   
    
        history.replace("/"+route)
    
    }

    return (
        <Tabs className="home--tab col-xs-6" defaultActiveKey={active_tab} onSelect={(k) => handleSelect(k)} activeKey={active_tab} >
            <Tab className="tab_bg" eventKey="aziende" title={<span><FontAwesomeIcon icon={faTractor}/> Aziende </span>}>
                <br />
                <Companies />
                <br />
            </Tab>
            <Tab className="tab_bg" eventKey="recensioni" title={<span><FontAwesomeIcon icon={faStar}/> Recensioni </span>}>
                <br />
                <Reviews filter={search_filter} />
                <br />
            </Tab>
            <Tab className="tab_bg" eventKey="community" title={<span><FontAwesomeIcon icon={faUsers}/> Community🔥 </span>}>
                <br />
                <Community/>
                <br />
            </Tab>
            <Tab className="tab_bg" eventKey="classifiche" title={<span><FontAwesomeIcon icon={faListOl}/> Classifiche </span>}>
                <br />
                <Ranking />
                <br />
            </Tab>
            <Tab className="tab_bg" eventKey="sconti" title={<span><FontAwesomeIcon icon={faTag}/> Sconti</span>}>
                <br />
                    <Sconti/>
                <br />
            </Tab>
            <Tab className="tab_bg" eventKey="info" title={<span><FontAwesomeIcon icon={faQuestionCircle}/> Info </span>}> 
                <br />
                    <Info/>
                <br />
            </Tab>
            <Tab className="tab_bg" eventKey="merch" title={<span><FontAwesomeIcon icon={faShoppingBasket}/> Merch </span>}> 
                <br />
                    <Merch/>
                <br />
            </Tab>
        </Tabs>
    );
}